import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Zotter Chocolates (b_d7zqrbdq, advertiser -2425147271178345382).
// Real numbers from ANALYTICS.ADS.CAMPAIGN_PERIODS (lifetime totals over the 29
// complete months Mar 2024 – Jul 2026). Monthly series + partial Aug 2026 live in
// realBrandData.ts.
//
// Under-utilized archetype, and the clearest case of it in the set: an $800
// monthly budget against $242/mo of actual spend, yet the strongest new-customer
// return of any variant at 7.7x. The reorder campaign is the reason to reach for
// this profile — it ran five months (Feb–Jun 2025) and stopped, so the reorder
// segment is a closed program sitting inside a live one. Nothing else here shows
// that shape.
//
// `budget.totalBudgetDollars` is the new-customers budget alone, not the sum of
// both campaigns: the reorder campaign's $300 stopped being charged in Jun 2025,
// and this figure sets the "monthly budget of $X" in the page header, which would
// otherwise claim $1,100 the advertiser hasn't budgeted in over a year. It also
// matches the Budget column on every recent month row.
//
// `spendingMode` is real here (ADS_SERVER.ADVERTISERS.spending_mode), unlike the
// variants where it's set only to give the growth-mode module a default.
export const advZotterChocolates: FaireAdvertiserProfileEntity = {
  token: "adv_zotter_chocolates",
  type: "advertiserProfile",
  archetype: "big-budget-under-utilized",
  displayName: "Chocolate Brand",
  brandToken: "b_d7zqrbdq",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 30,
  budget: {
    totalBudgetDollars: 800,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-09-01",
    nextBillsAtDate: "2026-09-04",
  },
  overview: {
    numCustomersAcquired: 69,
    numReorderConversions: 13,
    numTotalConversions: 82,
    // Booked sales, not the first-year projection. The two are further apart for
    // this advertiser than any other ($59.6k booked, $54.3k projected on the new
    // segment) because most of its cohorts are past their first year, so the
    // ROAS fields below cannot be reconstructed from these.
    totalAdsSalesDollars: 63054,
    newCustomerAdsSalesDollars: 59559,
    reorderAdsSalesDollars: 3495,
    totalAdsSpendDollars: 7361,
    newCustomerAdsSpendDollars: 7014,
    reorderAdsSpendDollars: 347,
    newCustomerBestEstimateFirstYearRoas: 7.74,
    reorderRoas: 10.07,
    combinedFirstYearRoas: 7.85,
    // MANAGER_METRICS_BRAND_ORDERS: 162 orders on the new-customer campaign
    // (from 69 acquired customers) and 15 on the reorder campaign.
    numNewCustomerAdsOrders: 162,
    numReorderAdsOrders: 15,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 200,
      maxRecommendedBudgetDollars: 400,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 100,
      maxRecommendedBudgetDollars: 200,
    },
  },
  campaignTokens: ["camp_zc_new", "camp_zc_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-30T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
